export type ChartData = [number, number][];
export enum DriftType {
	current = "current",
	A = "A",
	B = "B",
	C = "C",
	D = "D",
	Q1 = "1",
	Q2 = "2",
	Q3 = "3",
	Q4 = "4",
}

export interface ChartDataState {
	movingAverage: ChartData;
	maxMovingAverage: ChartData;
	minMovingAverage: ChartData;
	sigma1: ChartData;
	sigma2: ChartData;
	sigmaMinus1: ChartData;
	sigmaMinus2: ChartData;
}

export enum DriftPoint {
	QTR_END = "qtr_end",
	D7 = "7d",
	D20 = "20d",
	D70 = "70d",
}

export type PeadFilterType = "PEAD" | "Seasonal";
export type ReportCode = "AMC" | "BTO" | "DMT";

export interface GroupItem {
	date: number;
	adj_close?: number;
	division: string;
}

export interface SeriesDataItem extends GroupItem {
	normalizedPrice?: number;
}

export type QtrType = "20 Qtr" | "40 Qtr";

export type QtrSelectItem = {
	readonly id: number;
	readonly value: QtrType;
	readonly label: QtrType;
};

export type PeadTypeSelectItem = {
	readonly id: number;
	readonly value: PeadFilterType;
	readonly label: PeadFilterType;
};

export interface PEADState {
	ticker?: string;
	peadFilter?: PeadFilterType;
	historyType?: "Last" | "All";
	qtr?: QtrType;
	stdDev?: boolean;
	relativeToSpy?: boolean;
	color?: string;
}
